const media = {
  coverWidth: 1200,
  uploadMaxWidth: 1600,
  uploadMaxHeight: 1200
};

export default media;